import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function InstructorDetails() {
  const [instructor, setInstructor] = useState(null);
  const [activeTab, setActiveTab] = useState("description");
  const { id } = useParams();
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    const fetchInstructorDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/instructor/${id}`,
          {
            headers: {
              "Accept-Language": i18n.language,  // استخدام اللغة الحالية من i18next
            },
          }
        );
        
        const data = await response.json();
        if (data.type === "success") {
          setInstructor(data.data);
        } else {
          console.error("Error fetching instructor details:", data.message);
        }
      } catch (error) {
        console.error("Error fetching instructor details:", error);
      }
    };

    fetchInstructorDetails();
  }, [id, i18n.language]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const tabContent = {
    description: instructor?.description || t("loading"),
  };

  if (!instructor) {
    return <div>{t("loading")}</div>;
  }

  return (
    <>
      <div className="custom-section">
        <div className="container">
          <h1 className="m-0">{t("instructorsPage2.details")}</h1>
          <h6 className="m-0">
            <Link className="link-hover" to="/">{t("instructorsPage2.home")}</Link>
            <span> -</span>
            <Link className="link-hover mx-1" to="/Instructors">{t("instructorsPage2.title")}</Link>
            <span> - </span>
            <span className="second-color">{t("instructorsPage2.details")}</span>
          </h6>
        </div>
      </div>

      <section className="my-3">
        <div className="course-container  instructor-details-container">

          <div className="course-image mb-3">
            <img
              src={instructor.image}
              style={{ width: "300px", maxWidth: "100%" }}
              alt={instructor.name}
            />
            <h1 className="mt-3" style={{ fontSize: "25px" }}>
              {instructor.name}
            </h1>
          </div>

          {/* Instructor Overview - Always visible */}
          <h2 className="main-color mt-3" style={{fontSize : "20px"}}>{t("instructorsPage2.overview")}</h2>
          <p>{t("instructorsPage2.position")} : {instructor.position}</p>

          {/* Tabs */}
          <ul className="course-tabs mt-4 d-flex">
            <li
              className={`tab-item ${activeTab === "description" ? "active" : ""}`}
              onClick={() => handleTabClick("description")}
              style={{
                cursor: "pointer",
                borderBottom: activeTab === "description" ? "2px solid #F5993C" : "none",
              }}
            >
              {t("instructorsPage2.description")}
            </li>
          </ul>

          {/* Tab Content */}
          <div className="course-content mt-3">
            <p>{tabContent[activeTab]}</p>
          </div>
          <div className="mb-5">
          <h3 className="main-color" style={{fontSize : "20px"}}>{t("instructorsPage2.subjectsTitle")}</h3>
          <ul>
            {instructor.courses.length > 0 ? (
              instructor.courses.map((course, index) => (
                <li key={index}>{course.name}</li>
              ))
            ) : (
              <li>{t("instructorsPage2.noCourses")}</li>
            )}
            
          </ul>
        </div>
        </div>

    
      </section>
    </>
  );
}
